<script setup lang="ts">
const { locale } = useI18n({ useScope: 'global' });

const showFairnessPopup = ref(false);

function openFairnessPopup(e: Event) {
  e.preventDefault();
  showFairnessPopup.value = true;
}

function closeFairnessPopup() {
  showFairnessPopup.value = false;
}
</script>

<template>
   <footer>
      <div class="footer pc_footer">
        <h1 class="footer_logo">
          <img v-if="locale === 'ko'" src="/resources/images/logo_white.png" alt="푸터로고">
          <span v-else class="footer-logo-text">KGCT</span>
        </h1>
        <div class="siteinfo">
          <address v-if="locale === 'ko'">
            <ul>
              <li><strong>서울 본사</strong> : 서울특별시 송파구 법원로11길 25, 에이치비즈니스파크 A동 9층 (TEL: 02-525-1025 / FAX: 02-525-1026)</li>
              <li><strong>세종 지사</strong> : 세종특별자치시 국세청로 32, 마크원애비뉴 A동 9층 (TEL: 044-715-5447 / FAX: 044-715-5448)</li>
              <li><strong>부산 지사</strong> : 부산광역시 동구 중앙대로 240, 현대해상화재보험빌딩 5층 (TEL: 051-468-7011 / FAX: 051-468-7012)</li>
            </ul>
          </address>
          <address v-else>
            <ul>
              <li><strong>Seoul HQ</strong> : 9F H Business Park A, 25 Beopwon-ro 11-gil, Songpa-gu, Seoul (TEL: 02-525-1025 / FAX: 02-525-1026)</li>
              <li><strong>Sejong Office</strong> : 9F Mark One Avenue A, 32 Gukseocheong-ro, Sejong (TEL: 044-715-5447 / FAX: 044-715-5448)</li>
              <li><strong>Busan Office</strong> : 5F Hyundai M&amp;F Insurance Bldg, 240 Jungang-daero, Dong-gu, Busan (TEL: 051-468-7011 / FAX: 051-468-7012)</li>
            </ul>
          </address>
          <p class="copyright" v-if="locale === 'ko'">Copyright 2024. 한국녹색기후기술원 All Rights Reserved.</p>
          <p class="copyright" v-else>Copyright 2024. Korea Institute of Green Climate Technology. All Rights Reserved.</p>
        </div>
        <div class="col_area">
          <ul class="add">
            <li v-if="locale === 'ko'"><a href="#none" @click="openFairnessPopup">공정성 보장 선언문</a></li>
            <li v-else><a href="#none" @click="openFairnessPopup">Fairness Declaration</a></li>
            <li v-if="locale === 'ko'"><a href="/policy/policy03" target="_blank">이메일 무단 수집 거부</a></li>
            <li v-else><a href="/policy/policy03" target="_blank">No Email Scraping</a></li>
          </ul>
          <div class="family">
            <a v-if="locale === 'ko'" href="#none" class="btn_family" title="관련 사이트 보기">관련 사이트</a>
            <a v-else href="#none" class="btn_family" title="Related Sites">Related Sites</a>
            <ul class="family_list" v-if="locale === 'ko'">
              <li><a href="https://kolas.kgct.or.kr/" target="_blank" title="한국에너지공단 새창열림">SW 시험인증센터</a></li>
              <li><a href="http://www.molit.go.kr/portal.do" target="_blank" title="국토교통부 새창열림">국토교통부</a></li>
              <li><a href="https://www.moe.go.kr/" target="_blank" title="교육부 새창열림">교육부</a></li>
              <li><a href="http://www.motie.go.kr/www/main.do" target="_blank" title="산업통상자원부 새창열림">산업통상자원부</a></li>
              <li><a href="http://me.go.kr/home/web/main.do" target="_blank" title="환경부 새창열림">환경부</a></li>
              <li><a href="https://www.seoul.go.kr/main/index.jsp" target="_blank" title="서울특별시 새창열림">서울특별시</a></li>
              <li><a href="https://www.energy.or.kr/" target="_blank" title="한국에너지공단 새창열림">한국에너지공단</a></li>
            </ul>
            <ul class="family_list" v-else>
              <li><a href="https://kolas.kgct.or.kr/" target="_blank" title="SW Testing Center">SW Testing Center</a></li>
              <li><a href="http://www.molit.go.kr/portal.do" target="_blank" title="Ministry of Land">Ministry of Land</a></li>
              <li><a href="https://www.moe.go.kr/" target="_blank" title="Ministry of Education">Ministry of Education</a></li>
              <li><a href="http://www.motie.go.kr/www/main.do" target="_blank" title="MOTIE">Trade &amp; Industry</a></li>
              <li><a href="http://me.go.kr/home/web/main.do" target="_blank" title="Ministry of Environment">Ministry of Environment</a></li>
              <li><a href="https://www.seoul.go.kr/main/index.jsp" target="_blank" title="Seoul">Seoul Metropolitan</a></li>
              <li><a href="https://www.energy.or.kr/" target="_blank" title="Korea Energy Agency">Korea Energy Agency</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer m_footer">
        <h1 class="footer_logo">
          <img v-if="locale === 'ko'" src="/resources/images/logo_white.png" alt="푸터로고">
          <span v-else class="footer-logo-text">KGCT</span>
        </h1>
        <ul class="add">
          <li v-if="locale === 'ko'"><a href="#none" @click="openFairnessPopup">공정성 보장 선언문</a></li>
          <li v-else><a href="#none" @click="openFairnessPopup">Fairness Declaration</a></li>
          <li v-if="locale === 'ko'"><a href="/policy/policy03" target="_blank">이메일 무단 수집 거부</a></li>
          <li v-else><a href="/policy/policy03" target="_blank">No Email Scraping</a></li>
        </ul>
        <div class="siteinfo">
          <address v-if="locale === 'ko'">
            <ul>
              <li><strong>서울 본사</strong> : 서울특별시 송파구 법원로11길 25, 에이치비즈니스파크 A동 9층<br>
                (TEL: 02-525-1025 / FAX: 02-525-1026)
              </li>
              <li><strong>세종 지사</strong> : 세종특별자치시 국세청로 32, 마크원애비뉴 A동 9층<br>
                (TEL: 044-715-5447 / FAX: 044-715-5448)
              </li>
              <li><strong>부산 지사</strong> : 부산광역시 동구 중앙대로 240, 현대해상화재보험빌딩 5층<br>
                (TEL: 051-468-7011 / FAX: 051-468-7012)
              </li>
            </ul>
          </address>
          <address v-else>
            <ul>
              <li><strong>Seoul HQ</strong> : 9F H Business Park A, 25 Beopwon-ro 11-gil, Songpa-gu, Seoul<br>
                (TEL: 02-525-1025 / FAX: 02-525-1026)
              </li>
              <li><strong>Sejong Office</strong> : 9F Mark One Avenue A, 32 Gukseocheong-ro, Sejong<br>
                (TEL: 044-715-5447 / FAX: 044-715-5448)
              </li>
              <li><strong>Busan Office</strong> : 5F Hyundai M&amp;F Insurance Bldg, 240 Jungang-daero, Dong-gu, Busan<br>
                (TEL: 051-468-7011 / FAX: 051-468-7012)
              </li>
            </ul>
          </address>
        </div>
        <div class="col_area">
          <div class="family">
            <a v-if="locale === 'ko'" href="#none" class="btn_family" title="관련 사이트 보기">관련 사이트</a>
            <a v-else href="#none" class="btn_family" title="Related Sites">Related Sites</a>
            <ul class="family_list" v-if="locale === 'ko'">
              <li><a href="http://www.molit.go.kr/portal.do" target="_blank" title="국토교통부 새창열림">국토교통부</a></li>
              <li><a href="https://www.moe.go.kr/" target="_blank" title="교육부 새창열림">교육부</a></li>
              <li><a href="http://www.motie.go.kr/www/main.do" target="_blank" title="산업통상자원부 새창열림">산업통상자원부</a></li>
              <li><a href="http://me.go.kr/home/web/main.do" target="_blank" title="환경부 새창열림">환경부</a></li>
              <li><a href="https://www.seoul.go.kr/main/index.jsp" target="_blank" title="서울특별시 새창열림">서울특별시</a></li>
              <li><a href="https://www.energy.or.kr/" target="_blank" title="한국에너지공단 새창열림">한국에너지공단</a></li>
            </ul>
            <ul class="family_list" v-else>
              <li><a href="http://www.molit.go.kr/portal.do" target="_blank">Ministry of Land</a></li>
              <li><a href="https://www.moe.go.kr/" target="_blank">Ministry of Education</a></li>
              <li><a href="http://www.motie.go.kr/www/main.do" target="_blank">Trade &amp; Industry</a></li>
              <li><a href="http://me.go.kr/home/web/main.do" target="_blank">Ministry of Environment</a></li>
              <li><a href="https://www.seoul.go.kr/main/index.jsp" target="_blank">Seoul Metropolitan</a></li>
              <li><a href="https://www.energy.or.kr/" target="_blank">Korea Energy Agency</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div
        v-if="showFairnessPopup"
        class="fairness-popup"
        role="dialog"
        aria-modal="true"
        :aria-label="locale === 'ko' ? '공정성 보장 선언문' : 'Fairness Declaration'"
        @click.self="closeFairnessPopup"
      >
        <div class="fairness-popup__panel">
          <button type="button" class="fairness-popup__close" :aria-label="locale === 'ko' ? '닫기' : 'Close'" @click="closeFairnessPopup">
            ×
          </button>
          <div class="fairness-popup__body">
            <img
              src="/resources/images/certification/fairness_declaration.png"
              :alt="locale === 'ko' ? '공정성 보장 선언문' : 'Fairness Declaration'"
            />
          </div>
        </div>
      </div>
    </footer>
</template>

<style lang="scss" scoped>
.footer-logo-text {
  color: #fff;
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.fairness-popup {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.4rem;
  background: rgba(0, 0, 0, 0.65);
}

.fairness-popup__panel {
  position: relative;
  width: auto;
  max-width: min(56rem, calc(100vw - 4.8rem));
  max-height: calc(100vh - 4.8rem);
  background: #fff;
  border-radius: 0.4rem;
  box-shadow: 0 1.2rem 3.2rem rgba(0, 0, 0, 0.35);
  overflow: hidden;
}

.fairness-popup__close {
  position: absolute;
  top: 0.8rem;
  right: 1rem;
  z-index: 1;
  border: 0;
  background: transparent;
  color: #222;
  font-size: 2.8rem;
  line-height: 1;
  cursor: pointer;
}

.fairness-popup__body {
  max-height: calc(100vh - 4.8rem);
  overflow: hidden;
  padding: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fairness-popup__body img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: calc(100vh - 7.2rem);
}
</style>
